import { render, staticRenderFns } from "./OpList.vue?vue&type=template&id=4df32133&"
import script from "./OpList.vue?vue&type=script&lang=js&"
export * from "./OpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports